import "./styles.css";
import { ReactComponent as AnimalsIcon } from "../../../assets/svg/icons/animais.svg";

type BatchesSpecsDetailsProps = {
  batchLabel?: string;
  batchClassification?: string;
  qtdLabel?: string;
  capacity?: string;
  acreage?: string;
};

export function BatchesSpecsDetails({
  batchLabel,
  batchClassification,
  qtdLabel,
  capacity,
  acreage
}: BatchesSpecsDetailsProps) {
  return (
    <section>
      {batchLabel ? <div className="batchesspecsDetails__container_sigla">
        <AnimalsIcon fill={"#4D4D4D"} />
        <h3 className="loteDetails">{batchLabel}</h3>
      </div> : <br />}
      {batchClassification && <p className="batchesspecsDetails__classification">{batchClassification}</p>}
      {qtdLabel && (<h3 className="qtdDetails">{qtdLabel}</h3>)}
      {capacity && (<h3 className="capacity">{capacity} UA/HA</h3>)}
      {acreage && (<h3 className="acreage">{acreage} ha</h3>)}
    </section>
  );
}
